export const OPEN_SELECT_LOCATION = 'popup/OPEN_SELECT_LOCATION';
export const CANCEL_SELECT_LOCATION = 'popup/CANCEL_SELECT_LOCATION';

export const CANCEL_SELECT_LOCATION_FROM_CART = 'popup/CANCEL_SELECT_LOCATION_FROM_CART';

export const OPEN_MINICART = 'popup/OPEN_MINICART';
export const CANCEL_MINICART = 'popup/CANCEL_MINICART';

export const OPEN_PHONE = 'popup/OPEN_PHONE';
export const CANCEL_PHONE = 'popup/CANCEL_PHONE';

export const CANCEL_VERIFICATION_CODE = 'popup/CANCEL_VERIFICATION_CODE';
export const CONFIRM_VERIFICATION_CODE_RESEND = 'popup/CONFIRM_VERIFICATION_CODE_RESEND';

export const OPEN_ORDERS = 'popup/OPEN_ORDERS';
export const CANCEL_ORDERS = 'popup/CANCEL_ORDERS';

export const OPEN_PROFILE = 'popup/OPEN_PROFILE';
export const CANCEL_PROFILE = 'popup/CANCEL_PROFILE';

export const OPEN_SETTINGS = 'popup/OPEN_SETTINGS';
export const CANCEL_SETTINGS = 'popup/CANCEL_SETTINGS';

export const OPEN_NAME = 'popup/OPEN_NAME';
export const CANCEL_NAME = 'popup/CANCEL_NAME';
export const DONE_NAME = 'popup/DONE_NAME';

export const OPEN_EMAIL = 'popup/OPEN_EMAIL';
export const CANCEL_EMAIL = 'popup/CANCEL_EMAIL';
export const DONE_EMAIL = 'popup/DONE_EMAIL';

export const OPEN_BIRTHDAY = 'popup/OPEN_BIRTHDAY';
export const CANCEL_BIRTHDAY = 'popup/CANCEL_BIRTHDAY';
export const DONE_BIRTHDAY = 'popup/DONE_BIRTHDAY';

export const OPEN_OFFERS = 'popup/OPEN_OFFERS';
export const CANCEL_OFFERS = 'popup/CANCEL_OFFERS';

export const OPEN_CASHPOINTS = 'popup/OPEN_CASHPOINTS';
export const CANCEL_CASHPOINTS = 'popup/CANCEL_CASHPOINTS';

export const OPEN_SELECT_LANGUAGE = 'popup/OPEN_SELECT_LANGUAGE';
export const CANCEL_SELECT_LANGUAGE = 'popup/CANCEL_SELECT_LANGUAGE';
export const DONE_SELECT_LANGUAGE = 'popup/DONE_SELECT_LANGUAGE';

export const OPEN_INITIAL = 'popup/OPEN_INITIAL';
export const CANCEL_INITIAL = 'popup/CANCEL_INITIAL';

export const OPEN_MODIFIER_GROUP_EDIT = 'popup/OPEN_MODIFIER_GROUP_EDIT';
export const CANCEL_MODIFIER_GROUP_EDIT = 'popup/CANCEL_MODIFIER_GROUP_EDIT';

export const OPEN_CART_MODIFIER_GROUP_EDIT = 'popup/OPEN_CART_MODIFIER_GROUP_EDIT';
export const CANCEL_CART_MODIFIER_GROUP_EDIT = 'popup/CANCEL_CART_MODIFIER_GROUP_EDIT';

export const CANCEL_STRIPE_CARD_REGISTRATION = 'popup/CANCEL_STRIPE_CARD_REGISTRATION';

export const CANCEL_PROFILE_STRIPE_CARD_REGISTRATION = 'popup/CANCEL_PROFILE_STRIPE_CARD_REGISTRATION';

export const CANCEL_VIPPS_PAYMENT_FRAME = 'popup/CANCEL_VIPPS_PAYMENT_FRAME';

export const OPEN_DELIVERY_ADDRESS = 'popup/OPEN_DELIVERY_ADDRESS';
export const CANCEL_DELIVERY_ADDRESS = 'popup/CANCEL_DELIVERY_ADDRESS';
export const DONE_DELIVERY_ADDRESS = 'popup/DONE_DELIVERY_ADDRESS';

export const OPEN_DELIVERY_ADDRESS_FROM_CART = 'popup/OPEN_DELIVERY_ADDRESS_FROM_CART';
export const CANCEL_DELIVERY_ADDRESS_FROM_CART = 'popup/CANCEL_DELIVERY_ADDRESS_FROM_CART';
export const DONE_DELIVERY_ADDRESS_FROM_CART = 'popup/DONE_DELIVERY_ADDRESS_FROM_CART';

export const OPEN_PROMOCODE = 'popup/OPEN_PROMOCODE';
export const CANCEL_PROMOCODE = 'popup/CANCEL_PROMOCODE';
export const DONE_PROMOCODE = 'popup/DONE_PROMOCODE';

export const OPEN_TABLE_EDIT = 'popup/OPEN_TABLE_EDIT';
export const CANCEL_TABLE_EDIT = 'popup/CANCEL_TABLE_EDIT';
export const DONE_TABLE_EDIT = 'popup/DONE_TABLE_EDIT';

export const CANCEL_VIPPS_ERROR_MESSAGE = 'popup/CANCEL_VIPPS_ERROR_MESSAGE';
export const CANCEL_DISCOUNT_ERROR_MESSAGE = 'popup/CANCEL_DISCOUNT_ERROR_MESSAGE';

export const CANCEL_ZIP_EDIT = 'popup/CANCEL_ZIP_EDIT';
export const DONE_ZIP_EDIT = 'popup/DONE_ZIP_EDIT';

export const CANCEL_ZIP_EDIT_FROM_CART = 'popup/CANCEL_ZIP_EDIT_FROM_CART';
export const DONE_ZIP_EDIT_FROM_CART = 'popup/DONE_ZIP_EDIT_FROM_CART';

export const OPEN_DELETE_CARD = 'popup/OPEN_DELETE_CARD';

export const CANCEL_PICKUP_WARNING_MESSAGE = 'popup/CANCEL_PICKUP_WARNING_MESSAGE';
export const DONE_PICKUP_WARNING_MESSAGE = 'popup/DONE_PICKUP_WARNING_MESSAGE';

export const CANCEL_CARD_PAYMENT_WARNING_MESSAGE = 'popup/CANCEL_CARD_PAYMENT_WARNING_MESSAGE';
export const DONE_CARD_PAYMENT_WARNING_MESSAGE = 'popup/DONE_CARD_PAYMENT_WARNING_MESSAGE';

export const CANCEL_RESTAURANT_CLOSED_ERROR_MESSAGE = 'popup/CANCEL_RESTAURANT_CLOSED_ERROR_MESSAGE';

export const OPEN_LOGOUT_CONFIRMATION = 'popup/OPEN_LOGOUT_CONFIRMATION';
export const CANCEL_LOGOUT_CONFIRMATION = 'popup/CANCEL_LOGOUT_CONFIRMATION';
export const DONE_LOGOUT_CONFIRMATION = 'popup/DONE_LOGOUT_CONFIRMATION';

export const OPEN_EMAIL_RECEIPT = 'popup/OPEN_EMAIL_RECEIPT';
export const CANCEL_EMAIL_RECEIPT = 'popup/CANCEL_EMAIL_RECEIPT';
export const DONE_EMAIL_RECEIPT = 'popup/DONE_EMAIL_RECEIPT';

export const OPEN_EMAIL_ALL_RECEIPTS = 'popup/OPEN_EMAIL_ALL_RECEIPTS';
export const CANCEL_EMAIL_ALL_RECEIPTS = 'popup/CANCEL_EMAIL_ALL_RECEIPTS';
export const DONE_EMAIL_ALL_RECEIPTS = 'popup/DONE_EMAIL_ALL_RECEIPTS';

export const CANCEL_RESEND_VERIFICATION_CODE_MESSAGE = 'popup/CANCEL_RESEND_VERIFICATION_CODE_MESSAGE';

export const CANCEL_MODIFIERS_VALIDATION_ERROR_MESSAGE = 'popup/CANCEL_MODIFIERS_VALIDATION_ERROR_MESSAGE';

export const OPEN_NOTIFICATIONS = 'popup/OPEN_NOTIFICATIONS';
export const CANCEL_NOTIFICATIONS = 'popup/CANCEL_NOTIFICATIONS';

export const OPEN_REGISTRATION_POPUP = 'popup/OPEN_REGISTRATION_POPUP';

export const OPEN_CARD_STATUS = 'popup/OPEN_CARD_STATUS';
export const CANCEL_CARD_STATUS = 'popup/CANCEL_CARD_STATUS';
export const DONE_CARD_STATUS = 'popup/DONE_CARD_STATUS';

export const OPEN_DEBUG = 'popup/OPEN_DEBUG';
export const CANCEL_DEBUG = 'popup/CANCEL_DEBUG';

export const OPEN_INCOMPATIBLE_CART_CONFIRMATION = 'popup/OPEN_INCOMPATIBLE_CART_CONFIRMATION';
export const CANCEL_INCOMPATIBLE_CART_CONFIRMATION = 'popup/CANCEL_INCOMPATIBLE_CART_CONFIRMATION';
export const DONE_INCOMPATIBLE_CART_CONFIRMATION = 'popup/DONE_INCOMPATIBLE_CART_CONFIRMATION';

export const CANCEL_SEND_ORDER_ERROR_MESSAGE = 'popup/CANCEL_SEND_ORDER_ERROR_MESSAGE';

export const CANCEL_TERMS = 'popup/CANCEL_TERMS';
export const DONE_TERMS = 'popup/DONE_TERMS';

export const OPEN_LOCATION_PERMISSION_CONFIRMATION = 'popup/OPEN_LOCATION_PERMISSION_CONFIRMATION';
export const CANCEL_LOCATION_PERMISSION_CONFIRMATION = 'popup/CANCEL_LOCATION_PERMISSION_CONFIRMATION';
export const DONE_LOCATION_PERMISSION_CONFIRMATION = 'popup/DONE_LOCATION_PERMISSION_CONFIRMATION';

export const OPEN_ADD_TO_HOME_SCREEN = 'popup/OPEN_ADD_TO_HOME_SCREEN';
export const CANCEL_ADD_TO_HOME_SCREEN = 'popup/CANCEL_ADD_TO_HOME_SCREEN';
export const DONE_ADD_TO_HOME_SCREEN = 'popup/DONE_ADD_TO_HOME_SCREEN';

export const CANCEL_CUSTOM_PAYMENT_TYPE_WARNING_MESSAGE = 'popup/CANCEL_CUSTOM_PAYMENT_TYPE_WARNING_MESSAGE';
export const DONE_CUSTOM_PAYMENT_TYPE_WARNING_MESSAGE = 'popup/DONE_CUSTOM_PAYMENT_TYPE_WARNING_MESSAGE';

export const DONE_SERVER = 'popup/DONE_SERVER';

export const OPEN_REPEAT_ORDER_CONFIRMATION = 'popup/OPEN_REPEAT_ORDER_CONFIRMATION';
export const CANCEL_REPEAT_ORDER_CONFIRMATION = 'popup/CANCEL_REPEAT_ORDER_CONFIRMATION';
export const DONE_REPEAT_ORDER_CONFIRMATION = 'popup/DONE_REPEAT_ORDER_CONFIRMATION';

export const OPEN_REPEAT_ORDER_FROM_HISTORY_CONFIRMATION = 'popup/OPEN_REPEAT_ORDER_FROM_HISTORY_CONFIRMATION';
export const CANCEL_REPEAT_ORDER_FROM_HISTORY_CONFIRMATION = 'popup/CANCEL_REPEAT_ORDER_FROM_HISTORY_CONFIRMATION';
export const DONE_REPEAT_ORDER_FROM_HISTORY_CONFIRMATION = 'popup/DONE_REPEAT_ORDER_FROM_HISTORY_CONFIRMATION';

export const CANCEL_REPEAT_ORDER_MESSAGE = 'popup/CANCEL_REPEAT_ORDER_MESSAGE';

export const CANCEL_REPEAT_ORDER_MESSAGE_FROM_CART = 'popup/CANCEL_REPEAT_ORDER_MESSAGE_FROM_CART';

export const CANCEL_REPEAT_ORDER_ERROR_MESSAGE = 'popup/CANCEL_REPEAT_ORDER_ERROR_MESSAGE';

export const OPEN_MOBILE_PAY_ORDER_CANCELLED_ERROR_MESSAGE = 'popup/OPEN_MOBILE_PAY_ORDER_CANCELLED_ERROR_MESSAGE';
export const CANCEL_MOBILE_PAY_ORDER_CANCELLED_ERROR_MESSAGE = 'popup/OPEN_MOBILE_PAY_ORDER_CANCELLED_ERROR_MESSAGE';

export const CANCEL_MOBILE_PAY_RETURN_NO_STATE_ERROR_MESSAGE = 'popup/CANCEL_MOBILE_PAY_RETURN_NO_STATE_ERROR_MESSAGE';
export const DONE_MOBILE_PAY_RETURN_NO_STATE_ERROR_MESSAGE = 'popup/DONE_MOBILE_PAY_RETURN_NO_STATE_ERROR_MESSAGE';

export const CANCEL_MOBILE_PAY_RETURN_NO_URL_ERROR_MESSAGE = 'popup/CANCEL_MOBILE_PAY_RETURN_NO_URL_ERROR_MESSAGE';

export const CANCEL_MOBILE_PAY_INIT_ERROR_MESSAGE = 'popup/CANCEL_MOBILE_PAY_INIT_ERROR_MESSAGE';

export const ADYEN_CARD_REGISTRATION_POPUP = 'popup/ADYEN_CARD_REGISTRATION_POPUP';
export const PROFILE_ADYEN_CARD_REGISTRATION_POPUP = 'popup/PROFILE_ADYEN_CARD_REGISTRATION_POPUP';
export const CANCEL_ADYEN_CARD_REGISTRATION_POPUP = 'popup/CANCEL_ADYEN_CARD_REGISTRATION_POPUP';
export const CACNEL_ADYEN_CARD_CHECK_PAYMENT_ERROR_MESSAGE_POPUP = 'popup/CACNEL_ADYEN_CARD_CHECK_PAYMENT_ERROR_MESSAGE_POPUP';

export const CAUTH_CLEAR_CUSTOMER_DATA_POPUP = 'popup/CAUTH_CLEAR_CUSTOMER_DATA';

export const SWISH_PAY_POPUP = 'popup/SWISH_PAY_POPUP';
export const CANCEL_SWISH_PAY_POPUP = 'popup/CANCEL_SWISH_PAY_POPUP';
export const CANCEL_SWISH_PAY_CHECK_PAYMENT_STATUS_ERROR_MESSAGE = 'popup/CANCEL_SWISH_PAY_CHECK_PAYMENT_STATUS_ERROR_MESSAGE';

export const SLOW_SERVICE_POPUP = 'popup/SLOW_SERVICE_POPUP';
export const DONE_SLOW_SERVICE_CAPTION = 'popup/DONE_SLOW_SERVICE_CAPTION';
export const DONE_MOBILE_OAY_ANONYMOUS_INFO = 'popup/DONE_MOBILE_OAY_ANONYMOUS_INFO';

export const ADYEN_GOOGLE_PAY_POPUP = 'popup/ADYEN_GOOGLE_PAY_POPUP';
export const CANCEL_ADYEN_GOOGLE_PAY_POPUP = 'popup/CANCEL_ADYEN_GOOGLE_PAY_POPUP';
export const CANCEL_GOOGLE_PAY_CHECK_PAYMENT_STATUS_ERROR_MESSAGE = 'popup/CANCEL_GOOGLE_PAY_CHECK_PAYMENT_STATUS_ERROR_MESSAGE';

export const ADYEN_APPLE_PAY_POPUP = 'popup/ADYEN_APPLE_PAY_POPUP';
export const CANCEL_ADYEN_APPLE_PAY_POPUP = 'popup/CANCEL_ADYEN_APPLE_PAY_POPUP';
export const CANCEL_APPLE_PAY_CHECK_PAYMENT_STATUS_ERROR_MESSAGE = 'popup/CANCEL_APPLE_PAY_CHECK_PAYMENT_STATUS_ERROR_MESSAGE';

export const STRIPE_THREE_DS_POPUP = 'popup/STRIPE_THREE_DS_POPUP';
export const CANCEL_STRIPE_THREE_DS_POPUP = 'popup/CANCEL_STRIPE_THREE_DS_POPUP';

export const GUEST_ORDER_POPUP = 'popup/GUEST_ORDER_POPUP';
export const CANCEL_GUEST_ORDER_POPUP = 'popup/CANCEL_GUEST_ORDER_POPUP';

export const CANCEL_INITIAL_ORDER_POPUP = 'popup/CANCEL_INITIAL_ORDER_POPUP';


export const CONFIRM_GUEST_ORDER_POPUP = 'popup/CONFIRM_GUEST_ORDER_POPUP';
export const CANCEL_CONFIRM_GUEST_ORDER_POPUP = 'popup/CANCEL_CONFIRM_GUEST_ORDER_POPUP';
